import axios from 'axios'
import clientLogApi from '@/api/general/clientLog'
import store from '@/store'
import { globalModule } from '@/store/moduleName'

function showErrorMsgToUser (resp) {
  store.commit(globalModule + '/setHttpError', resp)
}

function sentErrorToBackEnd (error) {
  if (!error.response.config.url.includes('front-end/api/log')) {
    // console.log(error)
    // console.log(error.response)
    // console.log(error.response.data)
    // console.log(error.response.config.data)
    // console.log(error.response.config.url)
    // console.log(error.response.status)
    // console.log(error.response.statusText)
    let errLog = {
      'responseData': JSON.stringify(error.response.data),
      'responseConfigData': JSON.stringify(error.response.config.data),
      'url': error.response.config.url,
      'status': error.response.status,
      'statusText': error.response.statusText
    }
    console.error(errLog)
    clientLogApi.submitHttpErrorStatus(errLog, cb => {})
  } else {
    console.error('front-end/api/log error')
  }
}

export default {
  setup: () => {
    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response
    }, function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      if (error.response.data.path !== '/api/1.0.1/pn/wf/instance/counts') {
        showErrorMsgToUser(error.response)
      }
      sentErrorToBackEnd(error)

      return Promise.reject(error)
    })
  }
}
